import { IRoleItemViewModel } from "../../../model/respone/user/IRole";
import { eRoleActionTypeIds } from "../../action-types/user/IRoleActionTypes";
import { baseAction } from "../IActionBase";

export const roleAction = {
    loadStart: () => baseAction(eRoleActionTypeIds.LOAD_START, undefined),
    loadSuccess: (data: IRoleItemViewModel[]) => baseAction(eRoleActionTypeIds.LOAD_SUCCESS, data),
    loadError: (message?: string) => baseAction(eRoleActionTypeIds.LOAD_ERROR, message),
}